import { ConfigurableAppQueryArgs, useUserQuery } from '@alluradirect/react';
import { httpsUrlTrailingSlash, loginGuestUrl, loginHostUrl } from 'config/url';

export const useAppUserQuery = (useQueryOptions: ConfigurableAppQueryArgs = {}) => {
  return useUserQuery({
    ...useQueryOptions,
    onSuccess: data => {
      const isLoggedIn = Object.keys(data.DATA.USER).length > 0;
      if (!isLoggedIn) {
        // In an ideal world, we would be able to navigate to the login page.
        // However, when the user logs out, this query is invalidated and we need to direct the user somewhere.
        // Initially, I had them going to the log in page, but the requirement is to land on the home page.
        // This is not an ideal UX, in that if they have their browser open and the server rolls over, they will
        // be kicked to the home page.
        window.location.href = ( window.location.toString().search('guest') > 0 ? loginGuestUrl : loginHostUrl );
      }
    },
    onError: () => {
      window.location.href = httpsUrlTrailingSlash();
    },
  });
};
